import type { InjectionKey, Ref } from 'vue'
import type { LanguageCodes } from './cvTypes'

export type EditingType = 'new' | 'newmodels' | 'editmodels' | 'inputResources' | 'editPackage' | 'newImage' | 'listattr' | 'imagelist' | 'imageattr' | 'details' | 'references' | 'podcast' | 'prequiz' | 'assessment' | 'postquiz' | 'slideshow' | 'slideshowEdit' | 'assistantModeButtons' | 'finishassistantMode' | 'configAssistantMode' |'complainceAssistantMode'| 'helpSupportAssistant' | 'reportassistantMode' | 'feedbackAssistantMode' | 'examinerAssistantMode' | 'callAssistantMode' | 'Navigation' |  'readCallAssistantButton' |  'feedback' | 'assistantMode' | 'processingassistantMode' | 'feedbackList' | 'print' | 'notification' | 'lngReviewEdit'

type OpenMode = 'modal' | 'route'


export const SetEditingContextFn = Symbol() as InjectionKey<(id: string, type: EditingType, overrideURL: string | null | undefined, headerTitle: string | null | undefined) => void>



export type AppConfigDefinition = {
	detailsUrlTarget: string | null,
    hideHeaderActions: boolean
    hideHeaderFilters: boolean
    hideHeaderSearch: boolean
    hideDeleteActions: boolean
    hideHeader: boolean
    hidePagination: boolean
    hideActions: boolean
    hideFeedback: boolean
	hiddeAssistantComponent: boolean
	hideWorkflowStates: boolean
	forceDetailsId: string | null,
	showOnlyPostquiz: boolean,
	disabledLnguageSwitcher: boolean,
    editmode: boolean
    models: boolean
    urls: {
        getList?: string | null
        newPackage?: string | null
        newmodels?: string | null
        editmodels?: string | null
        editPackage?: string | null
		authoringStatusList: string | null,
		reviewStatusList: string | null,
		publishingStatusList: string | null,
        statuses?: string | null
        packageType?: string | null
		assistantCreate?: string
		assistantGenerate?: string,
		print?: {
			buttonLabel: string,
			toolTipLabel: string,
			openMode?: OpenMode
		}
		authoringStatuscfg:{
			authoringStatus: string | null,
			enabledAuthoringStatus: boolean,
			authoringDisabled: boolean
		},
		reviewStatuscfg:{
			reviewStatus: string | null,
			enabledReviewStatus: boolean,
			reviewDisabled: boolean
		},
		publishingStatuscfg:{
			publishingStatus: string | null,
			enabledpublishingStatus: boolean,
			publishingDisabled: boolean
		},

		assistantModeButtons?:{
			configButton:{
				enabled: boolean,
				configAssistantLink?: string | null

			},
			finishButton:{
				enabled: boolean,
				finishAssistantLink?: string | null
			},
			complainceButton:{
				enabled: boolean,
				complainceAssistantLink?: string | null,
			},
			helpSupportAssistantButton:{
				enabled: boolean,
			},
			feedbackAssistantButton:{
				enabled: boolean,
			},
			reportButton:{
				enabled: boolean,
				reportAssistantLink?: string | null,
			},
			readCallAssistantButton:{
				enabled: boolean,
				buttonLabel: string,
				toolTipLabel: string,
				readCallAssistantLink?: string | null,
			},
			callAssistantButton:{
				enabled: boolean,
				modal: boolean,
				url: string
			},
		},
		feedback?: {
			enabled: boolean,
			modal: boolean,
			url: string,
			listUrl: string,
			buttonLabel: string,
			toolTipLabel: string,
		},
		prequiz?: {
			modal: boolean,
			openMode?: OpenMode
		},
		postquiz?: {
			modal: boolean,
			openMode?: OpenMode
		},
		keymessage?: {
			modal: boolean,
			openMode?: OpenMode
		},
		assessment?: {
			modal: boolean,
			openMode?: OpenMode
		},
		presentation?: {
			openMode?: OpenMode
		},
		playerMode?: {
			openMode?: OpenMode
		},
		notification?: {
			buttonLabel: string,
			toolTipLabel: string,
			ReviewersURL?: string,
			LanguageReviewersURL?: string,
			EditorPublisherURL?: string,
			AudienceURL?: string,
			ProductionTeamURL?: string,
		}
    },
	defaultLng?: LanguageCodes
	medicalSpeciality?:string | null,
	authoringStatus?: string | null,
	publishingStatus?: string | null,
	studyType?:string | null
	studyMode?:string | null
	outcomeType?:string | null
	contentClassification?:string | null
	targetAudience?:string | null
	dashboardFilter?: string | null,
	latestDays?: number,
	aplicationDomain?:string | null
	collectionMode:string | null,
	testYourself?:string | null
	PAGE_REQ_ID?:string | null

}
export const ShowNavigationKey: InjectionKey<Ref<boolean>> = Symbol('ShowNavigation');



declare global {
    interface Window {
        MjcConfig?: Partial<AppConfigDefinition>
    }
}



export * from "./cvTypes"
export * from "./listposts"
export * from "./post"
export * from "./navigation"
